'use strict';

define('lib/analytics/blocks/list.block',[], function () {
  return function listBlock(count, layout) {
    return {
      list_result_count: count.toString(),
      list_layout: layout || ''
    };
  };
});

